<template>
    <div v-loading="loading">
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%; margin-bottom: 10px" min-height="530px">
                <el-table-column fixed show-overflow-tooltip label="请求时间" prop="RequestTime"> </el-table-column>
                <el-table-column fixed show-overflow-tooltip width="120" label="请求来源" prop="Source"> </el-table-column>
                <el-table-column show-overflow-tooltip  prop="Sponsor" label="查询人"></el-table-column>
            </el-table>
            <el-pagination
                v-if="tableDataLength != 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['VIN'],
    components: {},
    data() {
        return {
            loading: false,
            searchData: {
                VIN: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            tableDataLength: 0
        };
    },
    mounted() {
        this.searchData.VIN = this.VIN;
        this.getTableData();
    },
    methods: {
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/DataStatistics/VINReqRecords',
                    data: this.searchData
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    that.tableDataLength = res.count;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>

<style lang="less">
.uol-tooltip-content {
    text-align: right;
}
</style>
<style lang="less" scoped>
.tooltip-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
}
</style>
